<!---START: Wizard First Screen-->
<div *ngIf="this.isparentnotassociated===1 || this.isparentnotassociated===2"
  class="flex justify-between content-stretch items-stretch flex-col">

  <h1 mat-dialog-title id="addnewsite" style="margin: 0px 1px 13px 1px; ">
    <div class="flex justify-start content-center items-center flex-row">
      <div class="flex flex-row justify-start content-stretch items-stretch h-full basis-1/2">
        IMPORT WIZARD
      </div>
      <div class="flex flex-row justify-end content-stretch items-stretch h-full basis-1/2">
        <mat-icon (click)="dialogRefImportWizardComponent.close()" class="cross-wizard">
          <img src="/assets/img/icons/ico.16.clear.svg" alt="">
        </mat-icon>
      </div>

    </div>

  </h1>
  <app-import-wizard-first *ngIf="this.isparentnotassociated === 1 " [customerData]="this.customerData"
    (isCustomerMnemonicChange)="this.isCustomerMnemonic.setValue($event)" (parentFileName)="this.fielName=$event"
    (closeWizard)="closeDialog($event)" (deviceIdChange)="handleDeviceIdChange($event)"
    (countryIdChange)="handleCountryIdChange($event)" (dataSourceIdChange)="handleDataSourceIdChange($event)"
    (noUsageChange)="handleNoUsage($event)" (hideSide)="hidesite($event)"></app-import-wizard-first>

  <div *ngIf="this.isparentnotassociated===2"
    class="inner-mat-dialog flex flex-col justify-between content-stretch items-stretch w-full">
    <form [formGroup]="drugWithCanisterForm">
      <div>

        <mat-dialog-content #dialogContent class="add-site-exitorg-container">
          <!--START: Uploaded File Name-->
          <label> Document</label>
          <p style="font-weight: bold !important;">{{fielName}}</p>
          <!--END: Uploaded File Name-->

          <!--START: DATA SOURCE -->
          <div class="sub-device flex flex-row" style="margin-bottom: 10px;"
            [class.data-source-locked]="isDrugValidationEnabled && countryName === 'USA'">
            <mat-form-field floatLabel="never" class="sm:basis-[47%] basis-[17.3%]">
              <label>
                <span>
                  <mat-icon class="cross-wizard" style="margin-bottom: 13px;">
                    <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                  </mat-icon>
                </span>
                <span>Data Source</span>
              </label>
              <mat-select *ngIf="countryName === 'USA'" formControlName="dataSourceId" (selectionChange)="onDataSourceSelected($event.value)">
                <ng-container *ngFor="let source of datasourceList">
                  <mat-option *ngIf="source.value.includes('USA')" [value]="source.key">
                    {{ source.value }}
                    <span class="help_icon" [matTooltip]="source.description" matTooltipPosition="after"
                      matTooltipClass="custom_tooltip">
                      <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
                    </span>
                  </mat-option>
                </ng-container>
              </mat-select>
              <mat-select *ngIf="countryName==='CANADA'" formControlName="dataSourceId">
                <mat-option [value]="'4'">DPD(CAN)
                  <span class="help_icon" [matTooltip]="'Preferred data source in the CANADA'"
                    matTooltipPosition="after" matTooltipClass="custom_tooltip">
                    <img src="../../../../../assets/img/icons/ico.16.info.svg" alt="">
                  </span>
                </mat-option>
              </mat-select>
              <mat-error *ngIf="dataSourceId.hasError('required')">Data source required</mat-error>
            </mat-form-field>
          </div>
          <!--END: DATA SOURCE -->

          <!-- START: Language Model Dropdown -->
          <div class="sub-device flex flex-row" style="margin-bottom: 10px;" *ngIf="this.deviceId === 4">
            <mat-form-field floatLabel="never" class="sm:basis-[47%] basis-[17.3%]">
              <label>
                <span>
                  <mat-icon class="cross-wizard" style="margin-bottom: 13px;">
                    <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                  </mat-icon>
                </span>
                <span>Language Model</span>
              </label>
              <mat-select formControlName="synMedLanguage">
                <mat-option [value]="'ENG'">English</mat-option>
                <mat-option [value]="'FR-CA'">French Canadian</mat-option>
              </mat-select>
              <mat-error *ngIf="synMedLanguage.hasError('required')">
                Language model required
              </mat-error>
            </mat-form-field>
          </div>
          <!-- END: Language Model Dropdown -->

          <!--START: Device Type Dropdown -->
          <div style="padding-top: 10px;" class="flex flex-row">
            <div floatLabel="never" fxLayout="column" class="sm:basis-[47%] basis-[17.3%]">
              <label>
                <span> Device: <b>{{this.deviceName}}</b> </span>
              </label>
            </div>
            <div floatLabel="never" fxLayout="column" class="sm:basis-[47%] basis-[17.3%]">
              <label>
                <span> Country: <b>{{this.countryName}}</b> </span>
              </label>
            </div>
          </div>
          <!--END: Device Type Dropdown -->

          <!--START: Device Sub Type Dropdown: ATP  & Synmed DEVICE -->
          <div class="sub-device flex flex-row" style="margin-bottom: 10px;"
            *ngIf="this.deviceId===2 || this.deviceId===3 || this.deviceId === 4 || this.deviceId ===6">
            <mat-form-field floatLabel="never" class="sm:basis-[47%] basis-[17.3%]">
              <label>
                <span>
                  <mat-icon class="cross-wizard" style="margin-bottom: 13px;">
                    <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                  </mat-icon>
                </span>
                <span>Device Sub-Type</span>
              </label>
              <mat-select [disabled]="subdeviceTypes.length==0" (selectionChange)="isDisabled()"
                formControlName="deviceTypeId">
                <div class="search-wrapper" style="padding: 9px">
                  <div class="search-container">
                    <app-icon icon="search" class="icon_search"></app-icon>
                    <input class="search-input" inputId="searchcustomers-input" minLengthToSearch="1"
                      placeholder="Search" formControlName="searchText" id="search_customers">
                    <app-icon icon="clear" *ngIf="searchText.value != null" (click)="searchText.reset()" id="data-clear"
                      class="pointer"></app-icon>
                  </div>
                </div>
                <mat-option
                  *ngFor="let subtype of subdeviceTypes| filter: {subDeviceTypeName : searchText.value} : false"
                  [value]="subtype.subDeviceTypeId">{{subtype.subDeviceTypeName}}</mat-option>
              </mat-select>
              <mat-error *ngIf="deviceTypeId.hasError('required')">Device sub-type required</mat-error>
            </mat-form-field>
          </div>
          <!--END: Device Sub Type Dropdown: ATP & Synmed DEVICE -->

          <!--START: SYNMED Device => Robot Number-->
          <div style="margin-bottom: 10px;" *ngIf="this.deviceId === 4" class="flex flex-col">
            <label for="machineNumber" class="deviceType-label">
              <span>
                <mat-icon class="cross-wizard" style="margin-bottom: 13px;">
                  <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                </mat-icon>
              </span>
              <span>Customer Robot Number</span>
            </label>
            <div floatLabel="never" class="sm:basis-[47%] basis-1/4">
              <input id="machineNumber" class="custom-input" formControlName="machineNumber" type="text">
            </div>
          </div>

          <!--START: Caps Device => Customer Number-->
          <div *ngIf="this.deviceId === 6" class="flex flex-col caps-device-field-group">
            <label for="customerNumber" class="deviceType-label">
              <span>
                <mat-icon class="cross-wizard required-asterisk-icon">
                  <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                </mat-icon>
              </span>
              <span>Customer Number</span>
            </label>
            <div floatLabel="never" class="sm:basis-[47%] basis-1/4">
              <input id="customerNumber" class="custom-input" formControlName="customerNumber" type="text">
            </div>
          </div>

          <!--START: Caps Device => Asset Number-->
          <div *ngIf="this.deviceId === 6" class="flex flex-col caps-device-field-group">
            <label for="capsAssetNumber" class="deviceType-label">
              <span>
                <mat-icon class="cross-wizard required-asterisk-icon">
                  <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                </mat-icon>
              </span>
              <span>Asset Number</span>
            </label>
            <div floatLabel="never" class="sm:basis-[47%] basis-1/4">
              <input id="capsAssetNumber" class="custom-input" formControlName="capsAssetNumber" type="text" maxlength="6">
              <mat-error *ngIf="capsAssetNumber.hasError('required')">
                Asset number is required
              </mat-error>
              <mat-error *ngIf="capsAssetNumber.hasError('invalidAssetNumber')">
                Asset number must be exactly 6 digits
              </mat-error>
              <mat-error *ngIf="capsAssetNumber.hasError('allZeros')">
                Asset number cannot be all zeros
              </mat-error>
            </div>
          </div>


          <!--START: SYNMED Device =>Drug ID-->
          <div class="synmed-device flex" style="margin-bottom: 10px;" *ngIf="isCustomerMnemonic.value === true">
            <mat-form-field floatLabel="never" class="sm:basis-[47%] sm:w-[47%] basis-[17.3%] w-[17.3%]">
              <label>
                <span>
                  <mat-icon class="cross-wizard" style="margin-bottom: 13px;">
                    <!-- <img src="/assets/img/icons/ico.asterisk.svg" alt=""> -->
                  </mat-icon>
                </span>
                <span>Drug ID</span>
              </label>
              <mat-select formControlName="ndcVariant">
                <mat-option *ngFor="let row of ndcVariantList" [value]="row.key">{{row.value}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!--END: SYNMED Device => Drug ID -->
          <!--START: DrugName choosen Dropdown: ATP DEVICE/ ATP(Caps) -->
          <div style="margin-bottom: 10px;">
            <h6 class="m-t-0 m-b-0" *ngIf="this.deviceId===3 || this.deviceId ===6">Choose the drug name
              export format</h6>
          </div>
          <div style="margin-bottom: 10px;" *ngIf="this.deviceId===3 || this.deviceId ===6"
            class="flex flex-row gap-2.5">

            <mat-form-field floatLabel="never" class="sm:basis-[21%] basis-[18%]">
              <label>
                <span>Primary Drug Name</span>
              </label>

              <mat-select formControlName="primaryDrugName">
                <mat-option *ngFor="let type of drugNameSource" [value]="type.value">
                  <ng-container *ngIf="type.key === 'Customer Drug Name'">
                    {{ type.key }}
                  </ng-container>
                  <ng-container *ngIf="type.key !== 'Customer Drug Name'">
                    {{ drugWithCanisterForm.get('dataSourceId').value == 5 ? 'WK ' : (drugWithCanisterForm.get('dataSourceId').value == 1 ? 'FDB ' : '') }}{{ type.key }}
                  </ng-container>
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field floatLabel="never" class="sm:basis-[21%] basis-[18%]">
              <label>
                <span>Secondary Drug Name</span>
              </label>

              <mat-select formControlName="secondaryDrugName">
                <mat-option *ngFor="let type of drugNameSource" [value]="type.value">
                  <ng-container *ngIf="type.key === 'Customer Drug Name'">
                    {{ type.key }}
                  </ng-container>
                  <ng-container *ngIf="type.key !== 'Customer Drug Name'">
                    {{ drugWithCanisterForm.get('dataSourceId').value == 5 ? 'WK ' : (drugWithCanisterForm.get('dataSourceId').value == 1 ? 'FDB ' : '') }}{{ type.key }}
                  </ng-container>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!--END: DrugName choosen Dropdown: ATP/ ATP(CAPS) DEVICE -->


          <!-- START : Exclution Section-->
          <div style="padding-top: .8rem;">
            <h6 class="m-t-0 m-b-0">Choose what to exclude from the attached file</h6>
            <div class="flex flex-row">
              <div floatLabel="never" class="file-type-config sm:basis-[47%] basis-[47.3%]">
                <mat-checkbox formControlName="isOtcExcluded" value="true">
                  Exclude</mat-checkbox>
                <span>Over the counter (OTC) drugs</span>

              </div>
            </div>

            <div class="flex flex-row">
              <div floatLabel="never" class="file-type-config sm:basis-[15.3%] basis-[15.3%]">
                <mat-checkbox (change)="resetDrugsCheckbox()" formControlName="isScheduleExcluded" [value]="true">
                  Exclude</mat-checkbox>
                <span>Schedule</span>
              </div>
              <div class="drug-checkbox-group">
                <mat-checkbox [disabled]="drugWithCanisterForm.get('isScheduleExcluded').value==false"
                  formControlName="drugTypeOne" [value]="'C-I'" (change)='onChange("C-I", $event.checked)'>
                  I</mat-checkbox>

                <mat-checkbox [disabled]="drugWithCanisterForm.get('isScheduleExcluded').value==false"
                  formControlName="drugTypeTwo" [value]="'C-II'" (change)='onChange("C-II", $event.checked)'>
                  II</mat-checkbox>
                <mat-checkbox [disabled]="drugWithCanisterForm.get('isScheduleExcluded').value==false"
                  formControlName="drugTypeThree" [value]="'C-III'" (change)='onChange("C-III", $event.checked)'>
                  III</mat-checkbox>

                <mat-checkbox [disabled]="drugWithCanisterForm.get('isScheduleExcluded').value==false"
                  formControlName="drugTypeFour" [value]="'C-IV'" (change)='onChange("C-IV", $event.checked)'>
                  IV</mat-checkbox>

                <mat-checkbox [disabled]="drugWithCanisterForm.get('isScheduleExcluded').value==false"
                  formControlName="drugTypeFive" [value]="'C-V'" (change)='onChange("C-V", $event.checked)'>
                  V</mat-checkbox>

                <span>Drugs</span>
              </div>

            </div>

            <div class="flex flex-row">
              <div floatLabel="never" class="file-type-config sm:basis-[15.3%] basis-[15.3%]">
                <mat-checkbox (change)="resetDrugsCheckbox()" formControlName="isNioshExcluded" [value]="true">
                  Exclude</mat-checkbox>
                <span>Niosh 2024 Drugs</span>
              </div>
              <div class="drug-checkbox-group">
                <mat-checkbox [disabled]="drugWithCanisterForm.get('isNioshExcluded').value ==false"
                  formControlName="drugAntineoplastic" [checked]="drugAntineoplastic.value==1" [value]="1"
                  (change)="onChangeNioshDrug(1, $event.checked)">
                  Table 1 Drugs</mat-checkbox>

                <mat-checkbox [disabled]="drugWithCanisterForm.get('isNioshExcluded').value ==false"
                  formControlName="drugNonAntineoplastic" [checked]="drugAntineoplastic.value==2" [value]="2"
                  (change)="onChangeNioshDrug(2, $event.checked)">
                  Table 2 Drugs</mat-checkbox>

              </div>

            </div>
            <div class="flex flex-row" *ngIf="drugWithCanisterForm.get('dataSourceId').value != 1">
              <div floatLabel="never" class="file-type-config sm:basis-[15.3%] basis-[15.3%]">
                <mat-checkbox formControlName="excludeAntibiotics" [value]="true">
                  AntiBiotic</mat-checkbox>

              </div>


            </div>
            <div class="flex flex-row">
              <div floatLabel="never" class="file-type-config sm:basis-[17.3%] basis-[17.3%] flex items-center">
                <mat-checkbox formControlName="isUnitOfUsageExcluded" (change)="resetDrugsCheckbox()" value="true" class="mr-2">
                  Exclude
                </mat-checkbox>
                <span>Drugs with low Qty Stock Bottles</span>
              </div>
              <div class="drug-checkbox-group">
                <mat-checkbox [disabled]="drugWithCanisterForm.get('isUnitOfUsageExcluded').value==false"
                  formControlName="unitOfUsageQty30" [value]="'30'" (change)='onChangeUnitOfUsage("30", $event.checked)'>
                  QTY 30</mat-checkbox>
                <mat-checkbox [disabled]="drugWithCanisterForm.get('isUnitOfUsageExcluded').value==false"
                  formControlName="unitOfUsageQty60" [value]="'60'" (change)='onChangeUnitOfUsage("60", $event.checked)'>
                  QTY 60</mat-checkbox>
                <mat-checkbox [disabled]="drugWithCanisterForm.get('isUnitOfUsageExcluded').value==false"
                  formControlName="unitOfUsageQty90" [value]="'90'" (change)='onChangeUnitOfUsage("90", $event.checked)'>
                  QTY 90</mat-checkbox>
              </div>
            </div>
            <div *ngIf="this.deviceId === 2">
              <div class="flex flex-row">
                <div class="cell-input basis-[22.3%]">
                  <input min="0" onkeypress="return !(event.charCode == 46)" [readonly]="this.isReadOnly"
                    formControlName="minimumDaysSupply" appPositiveNumberValidator type="number">
                  <label>Minimum Days Supply </label>
                </div>

                <!-- Auto Canisters -->
                <div class="flex flex-col">
                  <div class="cell-input basis-[25.3%]">
                    <input min="0" onkeypress="return !(event.charCode == 46)" [readonly]="this.isReadOnly"
                      formControlName="autoCanister" min="0" appPositiveNumberValidator type="number">
                    <label>Auto Canisters </label>
                  </div>
                  <mat-error *ngIf="drugWithCanisterForm.get('autoCanister')?.hasError('required')">
                    Auto Canisters is required.
                  </mat-error>
                  <mat-error
                    *ngIf="drugWithCanisterForm.get('autoCanister')?.hasError('autoCanisterInvalid') || drugWithCanisterForm.get('autoCanister')?.hasError('autoCanisterExceeded')">
                    {{ getAutoCanisterErrorMessage() }}
                  </mat-error>
                </div>
              </div>
              <!-- <div class="cell-input flex flex-row">
                    <div class="flex flex-row">
                      <span>
                        <mat-icon class="cross-wizard">
                          <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                        </mat-icon>
                      </span>
                    <div style="width:95px;">
                      <mat-form-field>
                        <mat-select formControlName="dayOfUse">
                          <mat-option *ngFor="let row of dayOfUsageList" [value]="row.key">{{row.key}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div style="padding-top: 0.8rem;">
                      <label > Customer Drug List Timespan </label>
                    </div>
                  </div>

                  <div class="cell-input flex flex-row">
                    <span>
                      <mat-icon class="cross-wizard">
                        <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                      </mat-icon>
                    </span>
                    <div style="width:105px;">
                  <mat-form-field>
                    <mat-select formControlName="daysOfWeek">
                      <mat-option *ngFor="let row of daysPerWeekList" [value]="row.key">{{row.key}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div style="padding-top: 0.8rem;">
                  <label>Days Per Week Pharmacy Open </label>
                </div>
                </div>
              </div> -->
            </div>



            <div *ngIf="this.deviceId===3 && drugWithCanisterForm.value.deviceTypeId" class="flex flex-row">
              <div class="cell-input">
                <input min="0" onkeypress="return !(event.charCode == 46)" [readonly]="this.isReadOnly"
                  formControlName="minimumDaysSupply" type="number">
                <label>Minimum Days Supply </label>
              </div>

              <div class="cell-input"><input min="0" (change)="atpValidationForAnalyze()"
                  onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly || drugWithCanisterForm.value.deviceTypeId===9"
                  formControlName="highCapDrawerNo" appPositiveNumberValidator type="number"><label>High Cap Drawer
                  <mat-icon class="cross-wizard">
                    <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                  </mat-icon></label>
              </div>

              <div class="cell-input"><input min="0" (change)="atpValidationForAnalyze()"
                  onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly || drugWithCanisterForm.value.deviceTypeId===9"
                  formControlName="highCapSmartDrawerNo" appPositiveNumberValidator type="number"><label>Smart High Cap
                  Drawer <mat-icon class="cross-wizard">
                    <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                  </mat-icon></label>
              </div>

              <div class="cell-input"><input min="0" (change)="atpValidationForAnalyze()"
                  onkeypress="return !(event.charCode == 46)" [readonly]="this.isReadOnly"
                  formControlName="smartDrawerNo" appPositiveNumberValidator type="number"><label>Smart Drawers
                  <mat-icon class="cross-wizard">
                    <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                  </mat-icon></label></div>
            </div>

            <div *ngIf="this.deviceId===6 && drugWithCanisterForm.value.deviceTypeId" class="flex flex-row">
              <div class="cell-input">
                <input min="0" onkeypress="return !(event.charCode == 46)" [readonly]="this.isReadOnly"
                  formControlName="minimumDaysSupply" type="number">
                <label>Minimum Days Supply </label>
              </div>

              <div class="cell-input"><input min="0" (change)="atpCapsValidationForAnalyze()"
                  onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly || drugWithCanisterForm.value.deviceTypeId===23"
                  formControlName="highCapDrawerNo" appPositiveNumberValidator type="number"><label>High Cap Drawer
                  <mat-icon class="cross-wizard">
                    <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                  </mat-icon></label>
              </div>

              <div class="cell-input"><input min="0" (change)="atpCapsValidationForAnalyze()"
                  onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly || drugWithCanisterForm.value.deviceTypeId===23"
                  formControlName="highCapSmartDrawerNo" appPositiveNumberValidator type="number"><label>Smart High Cap
                  Drawer <mat-icon class="cross-wizard">
                    <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                  </mat-icon></label>
              </div>

              <div class="cell-input"><input min="0" (change)="atpCapsValidationForAnalyze()"
                  onkeypress="return !(event.charCode == 46)" [readonly]="this.isReadOnly"
                  formControlName="smartDrawerNo" appPositiveNumberValidator type="number"><label>Smart Drawers
                  <mat-icon class="cross-wizard">
                    <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                  </mat-icon></label></div>
            </div>

            <div style="margin-top: .8rem;" class="flex flex-row"
              *ngIf="(this.deviceId===2 || this.deviceId===3 || this.deviceId===4 || this.deviceId===6) && drugWithCanisterForm.value.deviceTypeId">

              <div style="width:105px;">
                <mat-form-field>
                  <mat-select formControlName="dayOfUse">
                    <mat-option *ngFor="let row of dayOfUsageList" [value]="row.key">{{row.key}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div style="font: normal normal normal 14px/16px Lato; padding-top: .8rem; padding-right: .5rem;">
                <label> Customer Drug List Timespan </label>
              </div>
              <span>
                <mat-icon class="cross-wizard">
                  <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                </mat-icon>
              </span>
            </div>

          </div>
          <!-- END : Exclution Section-->

          <div *ngIf="this.deviceId>0" class="analyze-section flex flex-col">
            <div class="basis-[17.3%]">
              <button style="margin-bottom: .8rem;" mat-button class="btn-blue btn-md"
                [disabled]="isAnalyzeButtonDisabled()" (click)="onAnalyze()" id="Analyze"
                aria-label="Analyze" type="button">Analyze</button>
            </div>

            <mat-error *ngIf="(this.deviceId===1 || this.deviceId === 5) && countAnalysisDrugInfo.length===0"
              style="margin-top: 9px;">* Analyzation must be completed before adding a sub device
              type</mat-error>


            <div style="margin-top: .8rem;" class="flex flex-col"
              *ngIf="countAnalysisDrugInfo.length>0 && (this.deviceId===3 || this.deviceId ===6)">
              <div class="count-section flex flex-row">
                <span class="basis-[23%]">Available Locations: <b
                    *ngIf="countAnalysisDrugInfo[0]">{{countAnalysisDrugInfo[0].value}}</b></span>
                <span class="basis-[23%]">Available Smart Locations: <b
                    *ngIf="countAnalysisDrugInfo[1]">{{countAnalysisDrugInfo[1].value}}</b></span>
                <span class="basis-[23%]">Available HighCap Locations: <b
                    *ngIf="countAnalysisDrugInfo[2]">{{countAnalysisDrugInfo[2].value}}</b></span>
                <span class="basis-[23%]">Available Smart HighCap Locations: <b
                    *ngIf="countAnalysisDrugInfo[3]">{{countAnalysisDrugInfo[3].value}}</b></span>
              </div>
            </div>
            <div class="flex flex-col"
              *ngIf="countAnalysisDrugInfo.length>0 && (this.deviceId===1 || this.deviceId === 5)">
              <h5 style="margin: 16px 3px;">Cell Recommendation</h5>
              <div class="count-section flex flex-row">
                <span class="basis-[13.3%]">Super cell: <b>{{countAnalysisDrugInfo[2]?.value}}</b></span>
                <span class="basis-[12.3%]">Locking cell: <b>{{countAnalysisDrugInfo[5]?.value}}</b></span>
                <span class="basis-[12.3%]">Regular cell: <b>{{countAnalysisDrugInfo[4]?.value}}</b></span>
                <span class="basis-[16.3%]">Super locking cell:
                  <b>{{countAnalysisDrugInfo[3]?.value}}</b></span>
              </div>
            </div>
            <!--START: Device Sub Type Dropdown: MAX DEVICE -->
            <div class="sub-device flex" style="margin-bottom: 10px;"
              *ngIf="(this.deviceId===1 || this.deviceId === 5) && countAnalysisDrugInfo.length>0">

              <mat-form-field floatLabel="never" class="sm:basis-[47%] sm:w-[47%] basis-[17.3%] w--[17.3%]">
                <label>
                  <span>
                    <mat-icon class="cross-wizard" style="margin-bottom: 13px;">
                      <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                    </mat-icon>
                  </span>
                  <span>Device Sub-Type</span>
                </label>
                <mat-select [disabled]="subdeviceTypes.length==0" (selectionChange)="isDisabled()"
                  formControlName="deviceTypeId">
                  <div class="search-wrapper" style="padding: 9px">
                    <div class="search-container">
                      <app-icon icon="search" class="icon_search"></app-icon>
                      <input class="search-input" inputId="searchcustomers-input" minLengthToSearch="1"
                        placeholder="Search" formControlName="searchText" id="search_customers">
                      <app-icon icon="clear" *ngIf="searchText.value != null" (click)="searchText.reset()"
                        id="data-clear" class="pointer"></app-icon>
                    </div>
                  </div>

                  <mat-option
                    *ngFor="let subtype of subdeviceTypes| filter: {subDeviceTypeName : searchText.value} : false"
                    [value]="subtype.subDeviceTypeId">{{subtype.subDeviceTypeName}}</mat-option>



                </mat-select>
                <mat-error *ngIf="deviceTypeId.hasError('required')">Device sub-type
                  required</mat-error>

              </mat-form-field>

            </div>
            <!--END: Device Sub Type Dropdown: MAX DEVICE -->
            <div class="max-form-control flex flex-row gap-5">

              <!-- Minimum Days Supply -->
              <div class="cell-input flex flex-col basis-[13.3%]"
                *ngIf="(this.deviceId === 1 || this.deviceId === 5) && countAnalysisDrugInfo.length > 0 && noUsage.value == false">
                <div style="padding-bottom: 3px;">
                  <span>
                    <mat-icon class="cross-wizard">
                      <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                    </mat-icon>
                  </span>
                  <label>Minimum Days Supply: </label>
                </div>

                <input min="0" onkeypress="return !(event.charCode == 46)" [readonly]="this.isReadOnly"
                  formControlName="minimumDaysSupply" appPositiveNumberValidator type="number">
              </div>


              <!-- Days Per Week Pharmacy Open -->
              <div class="timespan-input flex flex-col basis-[15.3%]"
                *ngIf="countAnalysisDrugInfo.length > 0 && (this.deviceId === 1 || this.deviceId == 5) && noUsage.value == false">
                <div class="flex flex-row">
                  <span>
                    <mat-icon class="cross-wizard">
                      <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                    </mat-icon>
                  </span>
                  <label>Days Per Week Pharmacy Open </label>
                </div>
                <mat-form-field>
                  <mat-select formControlName="daysOfWeek">
                    <mat-option *ngFor="let row of daysPerWeekList" [value]="row.key">{{row.key}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Customer Drug List Timespan -->
              <div class="timespan-input flex flex-col basis-[15.3%]"
                *ngIf="countAnalysisDrugInfo.length > 0 && (this.deviceId === 1 || this.deviceId == 5) && noUsage.value == false">
                <div class="flex flex-row">
                  <span>
                    <mat-icon class="cross-wizard">
                      <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                    </mat-icon>
                  </span>
                  <label>Customer Drug List Timespan: </label>
                </div>
                <mat-form-field>
                  <mat-select formControlName="dayOfUse">
                    <mat-option *ngFor="let row of dayOfUsageList" [value]="row.key">{{row.key}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Super Cells -->
              <div class="cell-input flex flex-col basis-[10.3%]"
                *ngIf="countAnalysisDrugInfo.length > 0 && (this.deviceId === 1 || this.deviceId == 5)">
                <label>Super Cells: </label>
                <input onkeypress="return !(event.charCode == 46)" min="0" appPositiveNumberValidator
                  [readonly]="this.isReadOnlyForLite" (change)="validataionMessage()" formControlName="superCellNo"
                  type="number">


                <mat-error *ngIf="drugWithCanisterForm.get('superCellNo')?.errors?.invalidPositiveNumber">
                  Invalid input! Please enter a valid positive number.
                </mat-error>
              </div>

            </div>
            <div *ngIf="this.deviceId===3 && countAnalysisDrugInfo.length>0" class="flex flex-row">
              <div class="cell-input"><input min="0" onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly" (change)="atpValidationForAnalyze()" appPositiveNumberValidator
                  formControlName="initalCanister" type="number"> <label>Initial Canisters </label>
              </div>
              <div class="cell-input"><input min="0" onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly" (change)="atpValidationForAnalyze()" appPositiveNumberValidator
                  formControlName="smartCanister" type="number"><label>Initial Smart Canisters</label>
              </div>
              <div class="cell-input"><input min="0" onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly" (change)="atpValidationForAnalyze()" formControlName="highCapCanister"
                  type="number">
                <label>Initial High Cap Canisters</label>
              </div>
              <div class="cell-input"><input min="0" onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly" (change)="atpValidationForAnalyze()"
                  formControlName="smartHighCapCanister" type="number">
                <label>Initial Smart High Cap Canisters</label>
              </div>
            </div>

            <div *ngIf="this.deviceId ===6 && countAnalysisDrugInfo.length>0" class="flex flex-row">
              <div class="cell-input"><input min="0" onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly" (change)="atpCapsValidationForAnalyze()" appPositiveNumberValidator
                  formControlName="initalCanister" type="number"> <label>Initial Canisters </label>
              </div>
              <div class="cell-input"><input min="0" onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly" (change)="atpCapsValidationForAnalyze()" appPositiveNumberValidator
                  formControlName="smartCanister" type="number"><label>Initial Smart Canisters</label>
              </div>
              <div class="cell-input"><input min="0" onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly" (change)="atpCapsValidationForAnalyze()"
                  formControlName="highCapCanister" type="number">
                <label>Initial High Cap Canisters</label>
              </div>
              <div class="cell-input"><input min="0" onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly" (change)="atpCapsValidationForAnalyze()"
                  formControlName="smartHighCapCanister" type="number">
                <label>Initial Smart High Cap Canisters</label>
              </div>
            </div>



            <div floatLabel="never" class="type-configuration flex flex-col sm:grow-[47] sm:basis-0 grow-[17] basis-0"
              style="margin-top: 13px;"
              *ngIf="(this.deviceId === 1 || this.deviceId == 5) && countAnalysisDrugInfo.length>0">

              <label>
                <span>Configuration</span>
              </label>
              <div class="flex flex-row">
                <mat-radio-group formControlName="configuration" (change)="resetConfigValues()"
                  aria-label="Select an option" class="config-radio-button-group">
                  <mat-radio-button [value]="1"
                    [checked]="drugWithCanisterForm.value.configuration == 1">Standard</mat-radio-button>
                  <mat-radio-button [value]="3"
                    [checked]="drugWithCanisterForm.value.configuration == 3">Locking</mat-radio-button>
                  <mat-radio-button
                    [disabled]="drugWithCanisterForm.get('deviceTypeId').value == 3 || drugWithCanisterForm.get('deviceTypeId').value == 4"
                    [value]="2" [checked]="drugWithCanisterForm.value.configuration == 2">Custom</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="configuration.hasError('required')">Configuration is
                  required</mat-error>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <div class="toggle-container">
                  <mat-slide-toggle formControlName="isCellSecure" (change)="onToggleSourceChange($event)"
                    class="custom-toggle" color="primary">Cell Secure Kit
                  </mat-slide-toggle>

                </div>
              </div>

            </div>

            <div *ngIf="(this.deviceId === 1 || this.deviceId == 5) && countAnalysisDrugInfo.length>0"
              class="flex flex-row">
              <div class="cell-input basis-[16.3%]" *ngIf="drugWithCanisterForm.value.configuration==2">
                <label>locking cells: </label><input min="0" onkeypress="return !(event.charCode == 46)"
                  (change)="validataionMessage()" [readonly]="this.isReadOnly" formControlName="lockingCellNo"
                  width="51%" type="number">
              </div>
              <div class="cell-input basis-[18.3%]" *ngIf="drugWithCanisterForm.value.configuration==2">
                <label>super locking cells: </label><input onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly" appPositiveNumberValidator (change)="validataionMessage()" min="0"
                  formControlName="superLockingCellNo" width="51%" type="number">
              </div>
            </div>

            <div class="flex flex-row"
              *ngIf="(this.deviceId === 1 || this.deviceId == 5) && countAnalysisDrugInfo.length>0">
              <mat-radio-group formControlName="cellAssignment" (change)="resetEmptyValues()"
                aria-label="Select an option" class="config-radio-button-group">
                <mat-radio-button [value]="1" [checked]="drugWithCanisterForm.value.cellAssignment == 1">Assign drug to
                  all cell locations</mat-radio-button>
                <mat-radio-button [value]="2" [checked]="drugWithCanisterForm.value.cellAssignment == 2">Leave Some
                  Locations Empty</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="configuration.hasError('required')">Configuration is
                required</mat-error>
              &nbsp;&nbsp;&nbsp;&nbsp;

            </div>

            <div *ngIf="(this.deviceId === 1 || this.deviceId == 5) && countAnalysisDrugInfo.length>0"
              class="flex flex-row">

              <div class="cell-input basis-[16.3%]" *ngIf="drugWithCanisterForm.value.cellAssignment==2 ">
                <label>Regular cells: </label><input min="0" onkeypress="return !(event.charCode == 46)"
                  (change)="emptyCellValidataionMessage()" [readonly]="this.isReadOnly"
                  formControlName="emptyRegularCellNo" width="51%" type="number" [disabled]="drugWithCanisterForm.value.configuration==3">
              </div>

              <div class="cell-input basis-[18.3%]" *ngIf="drugWithCanisterForm.value.cellAssignment==2">
                <label>Super cells: </label><input onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly" appPositiveNumberValidator (change)="emptyCellValidataionMessage()"
                  min="0" formControlName="emptySuperCellNo" width="51%" type="number" [disabled]="drugWithCanisterForm.value.configuration==3">
              </div>

              <div class="cell-input basis-[16.3%]" *ngIf="drugWithCanisterForm.value.cellAssignment==2">
                <label>Locking cells: </label><input min="0" onkeypress="return !(event.charCode == 46)"
                  (change)="emptyCellValidataionMessage()" [readonly]="this.isReadOnly"
                  formControlName="emptyLockingCellNo" width="51%" type="number">
              </div>

              <div class="cell-input basis-[18.3%]" *ngIf="drugWithCanisterForm.value.cellAssignment==2">
                <label>Super locking cells: </label><input onkeypress="return !(event.charCode == 46)"
                  [readonly]="this.isReadOnly" appPositiveNumberValidator (change)="emptyCellValidataionMessage()"
                  min="0" formControlName="emptySuperLockingCellNo" width="51%" type="number">
              </div>



            </div>



            <div *ngIf="this.deviceId===2 && !this.isEmpty(passanalyzeData)" class="flex flex-col gap-2.5">

              <div class="count-section flex flex-row gap-3.5">
                <span class="basis-[20%]">Available Small Locations: <b>{{
                    this.passanalyzeData.availableSmallLocation}}</b></span>
                <span class="basis-[20%]">Available Large Locations:
                  <b>{{this.passanalyzeData.availableLargeLocation}}</b></span>


              </div>
              <div class="count-section flex flex-row gap-3.5">
                <span class="basis-[20%]">Small Canister Drugs:
                  <b>{{this.passanalyzeData.smallCanisterDrugs }}</b></span>
                <span class="basis-[20%]">Large Canister Drugs:
                  <b>{{this.passanalyzeData.largeCanisterDrugs }}</b></span>

              </div>

            </div>

            <div *ngIf="this.deviceId===2 && !this.isEmpty(passanalyzeData)" class="flex flex-row">
              <div class="cell-input basis-[21.3%]">
                <span>
                  <mat-icon class="cross-wizard">
                    <img src="/assets/img/icons/ico.asterisk.svg" alt="">
                  </mat-icon>
                </span>

                <input min="0" onkeypress="return !(event.charCode == 46)" (change)="validataionMessage()"
                  [readonly]="this.isReadOnly" formControlName="passInitialSmallCanister" width="51%" type="number">
                <label>Initial Canisters </label>
              </div>
            </div>


            <div *ngIf="this.deviceId===4 && !this.isEmpty(synmedAnalyzeData)" class="flex flex-row gap-2.5">

              <div class="count-section flex flex-col gap-2.5">
                <span class="basis-[13.3%]">Large Containers & Large Pipettes: <b>{{
                    this.synmedAnalyzeData.largeLargeCount}}</b></span>
                <span class="basis-[12.3%]">Large Containers & Either Pipettes:
                  <b>{{this.synmedAnalyzeData.largeEitherCount}}</b></span>
                <span class="basis-[12.3%]">Large Containers & Small Pipettes:
                  <b>{{this.synmedAnalyzeData.largeSmallCount }}</b></span>
                <span class="basis-[16.3%]">Non-Certified Drugs:
                  <b>{{this.synmedAnalyzeData.nonCetritifedDrugs}}</b></span>

              </div>
              <div class="count-section flex flex-col gap-2.5">
                <span class="basis-[12.3%]">Small Containers & Either Pipettes:
                  <b>{{this.synmedAnalyzeData.smallEitherCount }}</b></span>
                <span class="basis-[12.3%]">Small Containers &amp;amp; Small Pipettes:
                  <b>{{this.synmedAnalyzeData.smallSmallCount }}</b></span>
                <span class="basis-[16.3%]">Schedule II Drugs:
                  <b>{{this.synmedAnalyzeData.schedule2DrugCount}}</b></span>
                <span class="basis-[13.3%]">Fragile Drugs: <b>{{this.synmedAnalyzeData.fragileCount
                    }}</b></span>
              </div>
              <div class="count-section flex flex-col gap-2.5">
                <span class="basis-[13.3%]">Both Containers & Large Pipettes:
                  <b>{{this.synmedAnalyzeData.bothLargeCount}}</b></span>
                <span class="basis-[12.3%]">Both Containers & Either Pipettes: <b>{{
                    this.synmedAnalyzeData.bothEitherCount}}</b></span>
                <span class="basis-[12.3%]">Both Container & Small Pipettes:
                  <b>{{this.synmedAnalyzeData.bothSmallCount}}</b></span>
                <span class="basis-[16.3%]">Toggle Drugs: <b>{{this.synmedAnalyzeData.toggleCount}}</b></span>
              </div>
            </div>
          </div>
          <div #analyzeDiv><span></span></div>

        </mat-dialog-content>
      </div>

      <mat-dialog-actions *ngIf="this.isparentnotassociated===2"
        class="flex justify-end content-end items-end xs:flex xs:flex-col flex-row">
        <button mat-button class="btn-primary btn-md" (click)="dialogRefImportWizardComponent.close()"
          id="CancelNewUser" aria-label="Cancel" type="button">Cancel</button>
        <button mat-button *ngIf="showbackbutton" class="btn-primary btn-md m-l-16" (click)="hidesite(1)" id="Back"
          aria-label="Back" type="button">Back</button>

        <button *ngIf="this.deviceId!==4 && this.deviceId!==7" mat-button
          [ngClass]="{'btn-blue':drugWithCanisterForm.valid || analyzeOpened, 'btn-disabled':!drugWithCanisterForm.valid||!analyzeOpened}"
          [disabled]="!drugWithCanisterForm.valid || validataionMessage()|| atpValidationForAnalyze() || atpCapsValidationForAnalyze()"
          class="btn-md m-l-16" id="Next" (click)="drugWithCanisterInfoSave()" aria-label="Import" type="button">Next
        </button>

        <button *ngIf="this.deviceId===7" mat-button
          [ngClass]="{'btn-blue':this.parataConnectFlowDrugForm.valid || analyzeOpened, 'btn-disabled':!this.parataConnectFlowDrugForm.valid||!analyzeOpened}"
          [disabled]="!this.parataConnectFlowDrugForm.valid"
          class="btn-md m-l-16" id="Next" (click)="loadCustomerDrugListForLegacyConnect()" aria-label="Import" type="button">Next
        </button>

        <button *ngIf="this.deviceId ===4 " mat-button
          [ngClass]="{'btn-blue':drugWithCanisterForm.valid || analyzeOpened, 'btn-disabled':!drugWithCanisterForm.valid||!analyzeOpened ||!synmedValidation()}"
          [disabled]="!drugWithCanisterForm.valid" class="btn-md m-l-16" id="Next" (click)="synmedDrugSave()" id="Next"
          aria-label="Import" type="button">Next </button>
      </mat-dialog-actions>
    </form>
  </div>

</div>
<!---END: Wizard First Screen-->


<!--START: Import Wizard GCN-->


<app-import-wizard-duplicate-ndc [customerId]="this.customerId" [customerName]="this.customerName"
  [deviceId]="this.deviceId" (closeWizard)="closeDialog($event)" (hideSide)="hidesite($event)"
  *ngIf="this.isparentnotassociated === 3"></app-import-wizard-duplicate-ndc>

<!--END: Import Wizard GCN-->


<!--START: Group Canisters-->
<app-import-wizard-gcn-pass [customerId]="this.customerId" (closeWizard)="closeDialog($event)"
  (hideSide)="hidesite($event)"
  *ngIf="this.isparentnotassociated===4 && this.deviceId === 2"></app-import-wizard-gcn-pass>
<app-import-wizard-gcn-atp [customerId]="this.customerId" [highCapDrawerNo]="this.highCapDrawerNo.value"
  [highCapSmartDrawerNo]="this.highCapSmartDrawerNo.value" [smartDrawerNo]="this.smartDrawerNo.value"
  [deviceTypeId]="this.deviceTypeId.value" (closeWizard)="closeDialog($event)" (hideSide)="hidesite($event)"
  *ngIf="this.isparentnotassociated===4 && this.deviceId === 3"></app-import-wizard-gcn-atp>
<app-import-wizard-gcn-atp-caps [customerId]="this.customerId" [highCapDrawerNo]="this.highCapDrawerNo.value"
  [highCapSmartDrawerNo]="this.highCapSmartDrawerNo.value" [smartDrawerNo]="this.smartDrawerNo.value"
  [deviceTypeId]="this.deviceTypeId.value" (closeWizard)="closeDialog($event)" (hideSide)="hidesite($event)"
  *ngIf="this.isparentnotassociated===4 && this.deviceId === 6"></app-import-wizard-gcn-atp-caps>

<!--END: Import Wizard GCN-->
